import React, { Component } from "react";
import PageLayout from "./layout/pagelayout";
import { Zoom } from "react-preloaders";
import Keycloak from "keycloak-js";

const { ReactKeycloakProvider } = require("@react-keycloak/web");

export const keycloak = new Keycloak(
  process.env.REACT_APP_KEYCLOAK_CLIENT_PATH
);

class Secured extends Component {
  state = {
    isLoading: false,
  };
  componentDidMount() {
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({ isLoading: false });
      // ClearChartTitles();
    }, 1000);
  }

  render() {
    return (
      <ReactKeycloakProvider authClient={keycloak}>
        <Zoom customLoading={this.state.isLoading} background="gradient" />
        <PageLayout />
      </ReactKeycloakProvider>
    );
  }
}

export default Secured;
